import { TipCategory } from './MyWaysToSave';
import HandAndMoneyIcon from '../../static/HandAndMoney.svg';

export const COM_TIP_CATEGORIES: TipCategory[] = [
  {
    titleKey: 'WTS_HEATING_AND_COOLING',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'INSTALL_OR_UPGRADE_TO_A_SMART_THERMOSTAT',
        detailsKey: 'INSTALL_OR_UPGRADE_TO_A_SMART_THERMOSTAT_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'REPLACE_HVAC_AIR_FILTERS_REGULARLY',
        detailsKey: 'REPLACE_HVAC_AIR_FILTERS_REGULARLY_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'SCHEDULE_HVAC_MAINTENANCE',
        detailsKey: 'SCHEDULE_HVAC_MAINTENANCE_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UPGRADE_OLDER_ELECTRIC_HEATING_EQUIPMENT',
        detailsKey: 'UPGRADE_OLDER_ELECTRIC_HEATING_EQUIPMENT_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'KEEP_VENTS_AND_REGISTERS_CLEAR',
        detailsKey: 'KEEP_VENTS_AND_REGISTERS_CLEAR_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'ADJUST_TEMPERATURES_AFTER_BUSINESS_HOURS',
        detailsKey: 'ADJUST_TEMPERATURES_AFTER_BUSINESS_HOURS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'SEAL_AIR_LEAKS_AROUND_DOORS_AND_WINDOWS',
        detailsKey: 'SEAL_AIR_LEAKS_AROUND_DOORS_AND_WINDOWS_DETAILS',
        renterFriendly: false,
      },
    ],
  },
  {
    titleKey: 'WTS_LIGHTING',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UPGRADE_TO_LED_LIGHTING',
        detailsKey: 'UPGRADE_TO_LED_LIGHTING_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'INSTALL_OCCUPANCY_SENSORS',
        detailsKey: 'INSTALL_OCCUPANCY_SENSORS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'ADD_LIGHTING_CONTROLS',
        detailsKey: 'ADD_LIGHTING_CONTROLS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_DIMMERS_WHERE_APPROPRIATE',
        detailsKey: 'USE_DIMMERS_WHERE_APPROPRIATE_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'TAKE_ADVANTAGE_OF_NATURAL_DAYLIGHT',
        detailsKey: 'TAKE_ADVANTAGE_OF_NATURAL_DAYLIGHT_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UPGRADE_EXTERIOR_LIGHTING',
        detailsKey: 'UPGRADE_EXTERIOR_LIGHTING_DETAILS',
        renterFriendly: false,
      },
    ],
  },
  {
    titleKey: 'WTS_EQUIPMENT_AND_OPERATIONS',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'TURN_OFF_IDLE_EQUIPMENT',
        detailsKey: 'TURN_OFF_IDLE_EQUIPMENT_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_ADVANCED_POWER_STRIPS',
        detailsKey: 'USE_ADVANCED_POWER_STRIPS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'ENABLE_POWER_SAVING_SETTINGS',
        detailsKey: 'ENABLE_POWER_SAVING_SETTINGS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'TRACK_ENERGY_USE',
        detailsKey: 'TRACK_ENERGY_USE_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'DEVELOP_STARTUP_AND_SHUTDOWN_PROCEDURES',
        detailsKey: 'DEVELOP_STARTUP_AND_SHUTDOWN_PROCEDURES_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'SCHEDULE_HIGH_ENERGY_ACTIVITIES_EFFICIENTLY',
        detailsKey: 'SCHEDULE_HIGH_ENERGY_ACTIVITIES_EFFICIENTLY_DETAILS',
        renterFriendly: false,
      },
    ],
  },
  {
    titleKey: 'WTS_OFFICE_SPACES',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'TURN_OFF_OFFICE_EQUIPMENT',
        detailsKey: 'TURN_OFF_OFFICE_EQUIPMENT_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'CONSOLIDATE_EQUIPMENT',
        detailsKey: 'CONSOLIDATE_EQUIPMENT_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_OCCUPANCY_SENSORS_IN_PRIVATE_OFFICES',
        detailsKey: 'USE_OCCUPANCY_SENSORS_IN_PRIVATE_OFFICES_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'REVIEW_AFTER_HOURS_HVAC_SCHEDULES',
        detailsKey: 'REVIEW_AFTER_HOURS_HVAC_SCHEDULES_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'ENCOURAGE_EMPLOYEE_PARTICIPATION',
        detailsKey: 'ENCOURAGE_EMPLOYEE_PARTICIPATION_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UPGRADE_OFFICE_LIGHTING',
        detailsKey: 'UPGRADE_OFFICE_LIGHTING_DETAILS',
        renterFriendly: false,
      },
    ],
  },
  {
    titleKey: 'WTS_RETAIL_SPACES',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'OPTIMIZE_DISPLAY_LIGHTING',
        detailsKey: 'OPTIMIZE_DISPLAY_LIGHTING_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'SCHEDULE_LIGHTING_BY_BUSINESS_HOURS',
        detailsKey: 'SCHEDULE_LIGHTING_BY_BUSINESS_HOURS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'CONTROL_LIGHTING_IN_STOCKROOMS',
        detailsKey: 'CONTROL_LIGHTING_IN_STOCKROOMS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'KEEP_ENTRANCE_DOORS_CLOSED',
        detailsKey: 'KEEP_ENTRANCE_DOORS_CLOSED_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UPGRADE_ILLUMINATED_SIGNAGE',
        detailsKey: 'UPGRADE_ILLUMINATED_SIGNAGE_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'REVIEW_REFRIGERATION_PERFORMANCE',
        detailsKey: 'REVIEW_REFRIGERATION_PERFORMANCE_DETAILS',
        renterFriendly: false,
      },
    ],
  },
  {
    titleKey: 'WTS_FOOD_SERVICE_AND_RESTAURANTS',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'TURN_OFF_COOKING_EQUIPMENT_WHEN_NOT_IN_USE',
        detailsKey: 'TURN_OFF_COOKING_EQUIPMENT_WHEN_NOT_IN_USE_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'MAINTAIN_REFRIGERATION_EQUIPMENT',
        detailsKey: 'MAINTAIN_REFRIGERATION_EQUIPMENT_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'INSTALL_LED_LIGHTING_IN_KITCHENS_AND_DINING_AREAS',
        detailsKey: 'INSTALL_LED_LIGHTING_IN_KITCHENS_AND_DINING_AREAS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_KITCHEN_EXHAUST_CONTROLS',
        detailsKey: 'USE_KITCHEN_EXHAUST_CONTROLS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'MAINTAIN_WALK_IN_COOLER_AND_FREEZER_DOORS',
        detailsKey: 'MAINTAIN_WALK_IN_COOLER_AND_FREEZER_DOORS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UPGRADE_REFRIGERATION_EQUIPMENT',
        detailsKey: 'UPGRADE_REFRIGERATION_EQUIPMENT_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'REDUCE_HOT_WATER_WASTE',
        detailsKey: 'REDUCE_HOT_WATER_WASTE_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'SCHEDULE_PREVENTATIVE_MAINTENANCE',
        detailsKey: 'SCHEDULE_PREVENTATIVE_MAINTENANCE_DETAILS',
        renterFriendly: false,
      },
    ],
  },
  {
    titleKey: 'WTS_PLANNING_AND_LONG_TERM_IMPROVEMENTS',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'MEET_WITH_AN_ENERGY_EXPERT',
        detailsKey: 'MEET_WITH_AN_ENERGY_EXPERT_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'CREATE_AN_ENERGY_MANAGEMENT_PLAN',
        detailsKey: 'CREATE_AN_ENERGY_MANAGEMENT_PLAN_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'TRAIN_STAFF_ON_ENERGY_SAVING_PRACTICES',
        detailsKey: 'TRAIN_STAFF_ON_ENERGY_SAVING_PRACTICES_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'REPLACE_AGING_EQUIPMENT_STRATEGICALLY',
        detailsKey: 'REPLACE_AGING_EQUIPMENT_STRATEGICALLY_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'EXPLORE_AVAILABLE_INCENTIVES',
        detailsKey: 'EXPLORE_AVAILABLE_INCENTIVES_DETAILS',
        renterFriendly: false,
      },
    ],
  },
];
